import { ENUM_LANGUAGE_CODE } from 'global.enums';
import { Resource } from 'i18next';
import arEnums from 'localizations/ar.enums.json';
import enEnums from 'localizations/en.enums.json';
import esEnums from 'localizations/es.enums.json';
import idEnums from 'localizations/id.enums.json';
import { ar } from 'localizations/locales/ar';
import { en } from 'localizations/locales/en';
import { es } from 'localizations/locales/es';
import { id } from 'localizations/locales/id';
import { ms } from 'localizations/locales/ms';
import { pt } from 'localizations/locales/pt';
import { ru } from 'localizations/locales/ru';
import { th } from 'localizations/locales/th';
import { vi } from 'localizations/locales/vi';
import { zh } from 'localizations/locales/zh';
import arJson from 'localizations/lokalise/locales/ar.json';
import enGBJson from 'localizations/lokalise/locales/en-GB.json';
import esESJson from 'localizations/lokalise/locales/es-ES.json';
import idIDJson from 'localizations/lokalise/locales/id-ID.json';
import msMYJson from 'localizations/lokalise/locales/ms-MY.json';
import ptPTJson from 'localizations/lokalise/locales/pt-PT.json';
import ruJson from 'localizations/lokalise/locales/ru.json';
import thTHJson from 'localizations/lokalise/locales/th-TH.json';
import viVNJson from 'localizations/lokalise/locales/vi-VN.json';
import zhCNJson from 'localizations/lokalise/locales/zh-CN.json';
import msEnums from 'localizations/ms.enums.json';
import ptEnums from 'localizations/pt.enums.json';
import ruEnums from 'localizations/ru.enums.json';
import thEnums from 'localizations/th.enums.json';
import viEnums from 'localizations/vi.enums.json';
import zhEnums from 'localizations/zh.enums.json';

type LocaleCode = {
  [key in ENUM_LANGUAGE_CODE]: Resource;
};

export const localizationResources: LocaleCode = {
  [ENUM_LANGUAGE_CODE.en]: {
    translation: {
      ...en,
      ...enEnums,
      ...enGBJson,
    },
  },
  [ENUM_LANGUAGE_CODE.ru]: {
    translation: {
      ...ru,
      ...enEnums, // English used by default
      ...ruEnums,
      ...ruJson,
    },
  },
  [ENUM_LANGUAGE_CODE.zh]: {
    translation: {
      ...zh,
      ...enEnums, // English used by default
      ...zhEnums,
      ...zhCNJson,
    },
  },
  [ENUM_LANGUAGE_CODE.id]: {
    translation: {
      ...id,
      ...enEnums, // English used by default
      ...idEnums,
      ...idIDJson,
    },
  },
  [ENUM_LANGUAGE_CODE.ms]: {
    translation: {
      ...ms,
      ...enEnums, // English used by default
      ...msEnums,
      ...msMYJson,
    },
  },
  [ENUM_LANGUAGE_CODE.th]: {
    translation: {
      ...th,
      ...enEnums, // English used by default
      ...thEnums,
      ...thTHJson,
    },
  },
  [ENUM_LANGUAGE_CODE.vi]: {
    translation: {
      ...vi,
      ...enEnums, // English used by default
      ...viEnums,
      ...viVNJson,
    },
  },
  [ENUM_LANGUAGE_CODE.es]: {
    translation: {
      ...es,
      ...enEnums, // English used by default
      ...esEnums,
      ...esESJson,
    },
  },
  [ENUM_LANGUAGE_CODE.ar]: {
    translation: {
      ...ar,
      ...enEnums, // English used by default
      ...arEnums,
      ...arJson,
    },
  },
  [ENUM_LANGUAGE_CODE.pt]: {
    translation: {
      ...pt,
      ...enEnums, // English used by default
      ...ptEnums,
      ...ptPTJson,
    },
  },
};
